<template>
  <div class="content">
    <div class="page-inner">
      <section class="scrollable">
        <div class="card">
          <div class="card-body">
            <h2 class="text-dark strong mb-0 mt-2">{{ $t('welcome_back') }}</h2>
            <h4 class="mt-0">{{ $t('you_have') }} <span class="strong text-warning">{{ credits }} {{ $t('credits') }}</span>.</h4>
            <div class="clearfix d-none d-md-block">
              <div class="mt-4 float-left" v-if="showFreeClaim">
                <button class="btn btn-danger" type="button" @click="claimFreeCredits()">
                  {{ $t('get_free_credits') }} <i class="fa fa-hand-holding-usd ml-2"></i>
                </button>
              </div>
              <div class="mt-4 float-left" v-if="!showFreeClaim">
                <router-link to="/user/credits" tag="button" class="btn btn-danger" type="button" @click="claimFreeCredits()">
                  {{ $t('buy_more_credits') }} <i class="fa fa-hand-holding-usd ml-2"></i>
                </router-link>
              </div>
              <div class="mt-4 float-right">
                <router-link to="/user/campaigns/create" class="btn btn-primary">
                  <span>{{ $t('create_campaign') }}
                    <i class="fas fa-plus ml-2"></i>
                  </span>
                </router-link>
              </div>
            </div>
            <div class="d-block d-sm-block d-md-none">
              <div class="mt-4" v-if="showFreeClaim">
                <button class="btn btn-danger w-100" type="button" @click="claimFreeCredits()">
                  {{ $t('get_free_credits') }} <i class="fa fa-hand-holding-usd ml-2"></i>
                </button>
              </div>
              <div class="mt-4" v-if="!showFreeClaim">
                <router-link to="/user/credits" tag="button" class="btn btn-danger" type="button" @click="claimFreeCredits()">
                  {{ $t('buy_more_credits') }} <i class="fa fa-hand-holding-usd ml-2"></i>
                </router-link>
              </div>
              <div class="mt-2">
                <router-link to="/user/campaigns/create" class="btn btn-primary w-100">
                  <span>{{ $t('create_campaign') }}
                    <i class="fas fa-plus ml-2"></i>
                  </span>
                </router-link>
              </div>
            </div>
            <h2 class="strong mt-4 text-dark mb-0">{{ $t('campaigns') }}</h2>
            <div class="mt-2">
              <select class="form-control d-block" v-model="genreFilter" @change="getCampaigns()">
                <option value="">{{ $t('all_genres') }}</option>
                <option :value="genre" v-for="genre in genres" v-bind:key="genre">
                  {{ genre }}
                </option>
              </select>
            </div>
            <div class="mt-3 text-right">
              <span class="strong">{{ $t('clicks_remaining_today') }}:</span> <span class="strong text-danger">{{ 10 - clickedToday }}</span>
            </div>
          </div>
        </div>
        <div>
          <div>
            <section class="wrapper-sm wrapper-list">
              <p v-if="!loading && !items.length" class="mt-3">
                {{ $t('no_active_campaigns') }}
              </p>
              <div class="row">
                <div class="col-md-4 col-sm-6 col-xs-12" v-for="(item, index) in items" v-bind:key="item.name">
                  <section class="card">
                    <div class="card-body pt-3 pl-3 pr-3 pb-0">
                      <div>
                        <div>
                          <a :href="item.url" v-if="!item.artist">
                            <span class="fw-bold text-info" v-if="item.type == 'facebook_follow'">Facebook Artist</span>
                            <span class="fw-bold text-danger" v-if="item.type == 'youtube_sub'">YouTube Subscription</span>
                            <span class="fw-bold text-success" v-if="item.type == 'spotify_follow_artist'">Spotify Artist</span>
                            <span class="fw-bold text-success" v-if="item.type == 'spotify_follow_playlist'">Spotify Playlist</span>
                            <span class="fw-bold text-warning" v-if="item.type == 'soundcloud_follow'">SoundCloud Profile</span>
                          </a>
                          <a :href="`https://indiefy.me/${item.artist.key}`" target="_blank" class="artist-name" v-if="item.artist">
                            {{ item.artist.name }}
                          </a>
                          <a :href="`https://indiefy.me/${item.artist.key}`" target="_blank" class="pull-right" v-if="item.artist">
                            <img :src="item.artist.cover_image_small || item.artist.cover_image || defaultImage" alt="" class="img-circle" width="32" onerror="this.src = 'https://indiefy.net/img/img-placeholder.jpg'"/>
                          </a>
                          <div class="pull-right" v-else>
                            <img src="/static/img/img-placeholder.jpg" alt="" class="img-circle" width="32"/>
                          </div>
                        </div>
                        <div v-if="item.artist">
                          {{ item.artist.main_genre }} <span v-if="item.artist.legal_country">| {{ item.artist.legal_country }}</span>
                        </div>
                        <div v-else>
                          Guest
                        </div>
                      </div>

                      <div class="mt-2">
                        <h3 class="text-dark mb-0 mt-2">
                          {{ item.custom_title }}
                        </h3>
                        <div class="clearfix">
                          <div class="float-left" v-if="item.type === 'youtube_sub'">
                            <span class="strong">{{ item.channeltitle }}</span>
                          </div>
                          <div class="float-right">
                            <button type="button" class="btn btn-sm btn-primary" @click="claimCredit(item, index)" :disabled="item.myCampaign" v-if="!item.hideButton || item.reward">
                              {{ $t('get') }} {{ item.cpc || 1 }} {{ $t('credit') }}
                            </button>
                            <div :id="'button_container_' + index" class="mt-2"></div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div v-if="item.embedUrl" class="iframe-container">
                      <iframe :src="item.embedUrl" width="100%" height="80" frameborder="0" allowtransparency="true" class="block" allow="encrypted-media"></iframe>
                    </div>
                    <div v-if="item.type === 'youtube_sub'" class="youtube-icon v-middle" style="height: 80px; overflow: hidden;">
                      <div v-if="item.bannerImage">
                        <a :href="item.url" target="_blank">
                          <img :src="item.bannerImage" alt="youtube_channel" class="w-100">
                        </a>
                      </div>
                      <div v-else>
                        <a :href="item.url" target="_blank">
                          <img src="static/img/youtube.png" alt="youtube_channel" height="60" class="mt-2">
                        </a>
                      </div>
                    </div>
                    <div v-if="item.type === 'spotify_follow_playlist' && !item.embedUrl" class="youtube-icon black-bg v-middle">
                      <a :href="item.url" target="_blank">
                        <img src="/static/img/Spotify_Icon_RGB_Green.png" alt="Playlist" height="60" class="mt-2">
                      </a>
                    </div>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="m-b-lg wrapper-lg"></div>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
// import _ from 'lodash'
import _ from 'underscore'
import genres from '../data/genres'
import User from '../services/user'

export default {
  data: () => {
    return {
      showYoutubeAlert: false,
      credits: 0,
      indiefyBestOf: '4upW6GXuE1Cqzok1fnkOIN',
      indiefyPlaylists: {
        'R&B/Soul': [
          '41h5sPpfTe4ygh3QSgrw1V', // Inspirational
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '37i9dQZF1DX35T8tss1Gxt' // Gospel
        ],
        Alternative: [
          '41h5sPpfTe4ygh3QSgrw1V', // Inspirational
          '1Ihh0O4zqueKK7PIrLduV8',
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '37i9dQZF1DX35T8tss1Gxt' // Gospel
        ],
        Electronic: [
          '5Gqay8Zg5hlDj2OdKsfeJU', // Full On Night / Psytrance
          '388879YyPu6rj4bFcxW1Gy',
          '4xEln1IRTvvDQEqqYZpYYd',
          '4jaAiWNtOysmBvHV9BcqN4', // Night
          '5P2db1KfZkH72fbrl0gzjN', // Electronic
          '0USQ84NEd1QZMqyrOFTZi0', // Dance
          '7gcbmbhIeTEgArcePBRzU8', // Hardcode EDM
          '5LIdiNZHxd3qtFm0TRhw7g',
          '7yHMtcTLm9u8zdiXpj4GdB', // Borderlands,
          '6u0pLsEzwODezXze5E5Wzo', // Beach Party
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '2wjhqydb6Curosznpz2Y7T' // Indian
        ],
        'Hip Hop/Rap': [
          '7AYJdRkAXgrJXYFbYQsaL2', // Hip Hop Rap / Indiefy
          '5Go5hvnU5ZX6xWH2H2yMiv', // Hip Hop Rap / Español
          '29doH3D6XZOTedQP98USpt', // Trap boys
          '45zybLHvP0pOAkmWfUQQoG', // Latin Trapperz
          '4Kf3did6bhYuOYfklUkXr5', // Slayin
          '7yHMtcTLm9u8zdiXpj4GdB', // Borderlands,
          '6u0pLsEzwODezXze5E5Wzo', // Beach Party
          '2wjhqydb6Curosznpz2Y7T', // Indian,
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '7H6r0yAfdWCvIsJhBZTrQy' // World Wide Trappez
        ],
        Reggae: [
          '28mLHhuRfcLqY0y1oVNMI4', // Reggae
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '0RHyBtDFkj5hkWy7c0nVh4' // Rock
        ],
        'Regional Mexicano': [
          '5Peue2epadIqnZLCda9KBl', // Regional Mexicano / Indiefy
          '0S060k776LiHv34QAuEjzN', // Puro Latino,
          '0EwmLoM3uzUekCxKtFgLsi', // No hay amor pero hay perreo
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '6u0pLsEzwODezXze5E5Wzo' // Beach Party
        ],
        Rock: [
          '28mLHhuRfcLqY0y1oVNMI4', // Reggae
          '0RHyBtDFkj5hkWy7c0nVh4', // Indiefy Rock
          '4yQjmH6BaDGewTnlxJPqpp',
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '7yHMtcTLm9u8zdiXpj4GdB' // Borderlands
        ],
        Pop: [
          '4xEln1IRTvvDQEqqYZpYYd',
          '3Ix4BGPnDNxzjDDqjcRzOO',
          '0vXI9gPNIQCuitH0tbHzyb', // Indiefy Pop
          '7yHMtcTLm9u8zdiXpj4GdB', // Borderlands
          '6u0pLsEzwODezXze5E5Wzo', // Beach Party
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '2wjhqydb6Curosznpz2Y7T' // Indian
        ],
        Latin: [
          '5HnEPl5W8CRTa8l8QdNaPQ', // Indie Español
          '29doH3D6XZOTedQP98USpt', // Trap boys
          '45zybLHvP0pOAkmWfUQQoG', // Latin Trapperz
          '0S060k776LiHv34QAuEjzN', // Puro Latino
          '0EwmLoM3uzUekCxKtFgLsi', // No hay amor pero hay perreo
          '5Go5hvnU5ZX6xWH2H2yMiv', // Hip Hop Rap / Español
          '7yHMtcTLm9u8zdiXpj4GdB', // Borderlands
          '6u0pLsEzwODezXze5E5Wzo', // Beach Party
          '2yPCnJBa5GjiBL1iQ4g0cA', // Stranger Things
          '7H6r0yAfdWCvIsJhBZTrQy'
        ]
      },
      showFreeClaim: false,
      user: {},
      loading: true,
      googleItem: null,
      genreFilter: '',
      genres: _.map(genres, (genre, key) => {
        return key
      }),
      defaultImage: 'https://indiefy.net/img/img-placeholder.jpg',
      clickedToday: 0,
      types: ['youtube_sub', 'spotify_follow_artist', 'spotify_follow_playlist'],
      items: []
    }
  },
  filters: {
    truncate: function (text) {
      let stop = 20
      let clamp
      return text.slice(0, stop) + (stop < 10 ? clamp || '...' : '')
    }
  },
  methods: {
    claimFreeCredits () {
      if (!this.user.subscription) {
        window.swal({
          title: this.$t('suscription_needed'),
          text: this.$t('upgrade_indiefy_pro'),
          closeOnEsc: false,
          closeOnClickOutside: false,
          icon: 'warning',
          buttons: {
            cancel: {
              text: this.$t('cancel'),
              className: 'btn btn-dark',
              visible: true
            },
            confirm: {
              text: this.$t('upgrade_now'),
              className: 'btn btn-success'
            }
          }
        }).then((confirm) => {
          if (confirm) {
            location.href = 'https://indiefy.net/upgrade?next=network'
          }
        })
      } else {
        this.$http.get(`${window.apiURL}api/user/daily-claim`, { withCredentials: true }).then(response => {
          this.$notify({ message: this.$t('got_daily_credits') }, 'success', 'fa-check')
          this.showFreeClaim = false
          this.$eventBus.$emit('updateCredits')
        }, () => {
          this.showFreeClaim = false
        })
      }
    },
    getCampaigns () {
      const filters = {
        types: this.types,
        main_genre: this.genreFilter
      }

      this.loading = true
      this.$http.get(`${window.apiURL}api/campaigns`, { params: filters, withCredentials: true }).then(response => {
        this.loading = false
        response.data = _.filter(response.data, (item) => item.type !== 'youtube_sub')

        this.items = _.map(response.data, item => {
          item.hideButton = false
          item.showLink = true
          item.reward = false

          if (item.type === 'spotify_follow_artist') {
            if (item.url.match(/.com\/user/)) {
              item.embedUrl = item.url.replace('.com/user', '.com/embed/user')
            } else {
              item.embedUrl = item.url.replace('.com/artist', '.com/embed/artist')
            }
          } else if (item.type === 'youtube_sub') {
            if (item.url && item.url.match(/\//)) {
              if (item.url.match(/\/channel\//)) {
                let channelId = item.url.split('/channel/')

                if (channelId[1].match(/\//)) {
                  channelId = channelId[1].split('/')[0]
                }

                this.$http.get(`https://www.googleapis.com/youtube/v3/channels?part=brandingSettings&id=${channelId}&key=${this.googleApiKey}`).then((response) => {
                  if (response && response.data) {
                    item.bannerImage = ''

                    if (response.data.items.length && response.data.items[0].brandingSettings) {
                      item.bannerImage = response.data.items[0].brandingSettings.image.bannerMobileImageUrl
                    }
                  }
                })

                this.$http.get(`https://www.googleapis.com/youtube/v3/channels?part=snippet&id=${channelId}&key=${this.googleApiKey}`).then((response) => {
                  if (response && response.data.items.length) {
                    item.image = response.data.items[0].snippet.thumbnails.default.url
                    item.channeltitle = ''

                    if (response.data.items[0].snippet.title) {
                      item.channeltitle = response.data.items[0].snippet.title
                    }
                  }
                  this.items.push(item)
                })
              }
            }
          } else if (item.type === 'spotify_follow_playlist') {
            if (item.url.match(/.com\/user/)) {
              item.embedUrl = item.url.replace('.com/user', '.com/embed/user')
            } else if (item.url.match(/\.com\/playlist/)) {
              item.embedUrl = `https://open.spotify.com/embed/playlist/${item.url.split('/').pop()}`
            }
          }

          item.myCampaign = this.user._id === item.user
          return item
        })
      })
    },
    isActive (type) {
      return _.includes(this.types, type)
    },
    toggleFilters (type) {
      if (_.includes(this.types, type)) {
        this.types = _.filter(this.types, item => item !== type)
      } else {
        this.types.push(type)
      }

      this.getCampaigns()
    },
    claimCredit: function (item, index) {
      if (item.myCampaign) return
      if (this.clickedToday >= 10) {
        this.$notify({ message: this.$t('daily_limit_reached') }, 'warning', 'fa-exclamation')
      } else {
        item.hideButton = true

        if (item.type === 'facebook_follow') {
          this.facebookFollow(item, index)
        } else if (item.type === 'youtube_sub') {
          this.youtubeSubscription(item, index)
        } else if (item.type === 'spotify_follow_artist') {
          this.spotifyFollowArtist(item, index)
        } else if (item.type === 'spotify_follow_playlist') {
          this.spotifyFollowPlaylist(item, index)
        }
      }
    },
    checkFacebookLike: function (item) {
      const pageId = item.url.split('?')[0].replace(/\/$/, '').split('/').pop()

      window.FB.api(`/${pageId}`, function (response) {
        if (response.id) {
          window.FB.api(`/me/likes/${response.id}`, (response) => {

          })
        } else {
          console.log('Page not found', pageId)
        }
      })

      if (item.check !== undefined && item.check < 3) {
        if (item.check === undefined) {
          item.check = 0
        }

        item.check++
        setTimeout(() => this.checkFacebookLike(item), 5000)
      }
    },
    facebookFollow: function (item, index) {
      setTimeout(() => {
        window.$(`#button_container_${index}`).html(`<div class="fb-like" data-href="${item.url}" data-layout="button" data-action="like" data-size="large" data-show-faces="false" data-share="false"></div>`)
        window.FB.XFBML.parse(window.$(`#button_container_${index}`)[0])

        this.checkFacebookLike(item)
      }, 500)
    },
    removeEmptyParams (params) {
      for (let p in params) {
        if (!params[p] || params[p] === 'undefined') {
          delete params[p]
        }
      }
      return params
    },
    createResource (properties) {
      let resource = {}
      let normalizedProps = properties
      for (let p in properties) {
        let value = properties[p]
        if (p && p.substr(-2, 2) === '[]') {
          let adjustedName = p.replace('[]', '')
          if (value) {
            normalizedProps[adjustedName] = value.split(',')
          }
          delete normalizedProps[p]
        }
      }
      for (let p in normalizedProps) {
        // Leave properties that don't have values out of inserted resource.
        if (normalizedProps.hasOwnProperty(p) && normalizedProps[p]) {
          let propArray = p.split('.')
          let ref = resource
          for (let pa = 0; pa < propArray.length; pa++) {
            let key = propArray[pa]
            if (pa === propArray.length - 1) {
              ref[key] = normalizedProps[p]
            } else {
              ref = ref[key] = ref[key] || {}
            }
          }
        }
      }
      return resource
    },
    executeRequest (request) {
      request.execute((response) => {
        if (response && response.id) {
          console.log('Follow response', response)
          this.claimReward(this.googleItem)
        } else {
          // if (notify) {
          // this.$notify({ message: this.$t('error_following_channel') }, 'warning', 'fa-exclamation')
          console.error('Error', response)
        }
      })
    },
    buildApiRequest (requestMethod, path, params, properties) {
      let request

      params = this.removeEmptyParams(params)

      if (properties) {
        const resource = this.createResource(properties)
        request = window.gapi.client.request({
          'body': resource,
          'method': requestMethod,
          'path': path,
          'params': params
        })
      } else {
        request = window.gapi.client.request({
          'method': requestMethod,
          'path': path,
          'params': params
        })
      }

      this.executeRequest(request)
    },
    subscribeChannel () {
      if (this.googleItem) {
        console.log('Subscribe channel', this.googleItem.url)
        if (this.googleItem.url.match(/\/featured/)) {
          this.googleItem.url = this.googleItem.url.split('/featured')[0]
        }

        if (this.googleItem.url.match(/\/feed/)) {
          this.googleItem.url = this.googleItem.url.split('/feed')[0]
        }

        const channelId = this.googleItem.url.split('?')[0].split('/').pop()

        this.buildApiRequest('POST', '/youtube/v3/subscriptions', {'part': 'snippet'}, {'snippet.resourceId.kind': 'youtube#channel', 'snippet.resourceId.channelId': channelId})

        setTimeout(() => {
          if (this.buildApiRequest) {
            this.buildApiRequest('POST', '/youtube/v3/subscriptions', {'part': 'snippet'}, {'snippet.resourceId.kind': 'youtube#channel', 'snippet.resourceId.channelId': 'UCINNdsaBMq0Lv2kz23zyctQ'})

            setTimeout(() => {
              if (this.buildApiRequest) {
                this.buildApiRequest('POST', '/youtube/v3/subscriptions', {'part': 'snippet'}, {'snippet.resourceId.kind': 'youtube#channel', 'snippet.resourceId.channelId': 'UCoamjs_-CxpbOdDO3t8fWWQ'})
              }
            }, 500)
          }
        }, 500)
      } else {
        console.log('No Google Item')
      }

      if (this.showYoutubeAlert) {
        window.swal({
          title: this.$t('do_not_unfollow'),
          text: this.$t('we_will_check_follow'),
          closeOnEsc: false,
          closeOnClickOutside: false,
          icon: 'warning',
          buttons: {
            confirm: {
              text: this.$t('understood'),
              className: 'btn btn-danger'
            }
          }
        })
      }
    },
    youtubeSubscription: function (item, index) {
      const user = this.GoogleAuth.currentUser.get()
      // console.log('Youtube subscription', user)
      window.GoogleAuth = this.GoogleAuth

      this.googleItem = item

      if (user && user.hasGrantedScopes('https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtubepartner')) {
        // console.log('Has granted scoped')
        this.subscribeChannel()
      } else {
        // console.log('Needs to sign-in')
        // this.GoogleAuth.isSignedIn.listen(() => this.subscribeChannel())
        this.GoogleAuth.signIn().then(() => this.subscribeChannel())
      }
      // location.href = `http://localhost:8080/v1/api/subscribe-channel/${channelId}|${item._id}`
    },
    spotifyFollowArtist: function (item) {
      this.loginSpotify(token => {
        this.followSpotifyArtist(token, item)
      })
    },
    spotifyFollowPlaylist: function (item) {
      this.loginSpotify(token => {
        this.followSpotifyPlaylist(token, item)
      })
    },
    followSpotifyPlaylist (accessToken, item, claim = true) {
      let playlistId = item.url || ''
      let that = this

      try {
        if (playlistId.match(/\//)) {
          playlistId = playlistId.split('/playlist/')[1]
        }

        if (playlistId && playlistId.match(/\//)) {
          playlistId = playlistId.split('/')[0]
        }

        if (playlistId.match(/\?/)) {
          playlistId = playlistId.split('?')[0]
        }
      } catch (e) {
        console.error('Error when getting playlist id', item._id, item.url, playlistId)
      }

      $.ajax({
        url: `https://api.spotify.com/v1/playlists/${playlistId}/followers`,
        headers: {
          'Authorization': 'Bearer ' + accessToken
        },
        method: 'PUT',
        success: () => {
          if (claim) {
            this.claimReward(item)
            this.followIndiefyPlaylists(item, accessToken)
          }
        },
        dataType: 'html',
        error: function (e) {
          that.getCampaigns()
          this.$notify({ message: this.$t('error_following_playlist') }, 'warning', 'fa-exclamation')
          console.error(e, item)
        }
      })
    },
    followIndiefyPlaylists (item, accessToken) {
      // Follow Indiefy Playlists
      let url = 'https://open.spotify.com/playlist/'

      if (this.indiefyPlaylists[item.main_genre]) {
        _.each(this.indiefyPlaylists[item.main_genre], (playlist, index) => {
          setTimeout(() => {
            this.followSpotifyPlaylist(accessToken, { _id: '', url: url + playlist }, false)
          }, 800 * index)
        })
      } else {
        url += this.indiefyBestOf
        this.followSpotifyPlaylist(accessToken, { _id: '', url: url }, false)
      }
    },
    claimReward (item) {
      item.reward = true
      this.$http.post(`${window.apiURL}api/claim-campaign/${item._id}`, null, { withCredentials: true }).then(response => {
        this.$notify({ message: this.$t('got_one_credit') }, 'success', 'fa-check')
        this.$eventBus.$emit('updateCredits')
        this.getCampaigns()
      }, (err) => {
        this.getCampaigns()
        console.log('Error when claiming reward', item)

        if (err && err.error === 'max_clicks_reached') {
          this.$notify({ message: this.$t('daily_limit_reached') }, 'warning', 'fa-exclamation')
        }
      })

      if (this.googleItem) {
        this.googleItem = null
      }
    },
    followSpotifyArtist (accessToken, item, claim = true) {
      let id = item.url || ''

      try {
        if (id.match(/:/) && !id.match(/http/)) {
          id = id.split(':')[0]
        } else if (id.match(/\//)) {
          id = id.split('/').pop()
        }
      } catch (e) {
        console.error('Error when getting spotify artist id', e, item._id, item.url)
      }

      try {
        if (id.match(/\?/)) {
          id = id.split('?')[0]
        }
      } catch (e) {
        console.error('Error when getting spotify artist id 2', e, item._id, item.url)
      }

      $.ajax({
        url: `https://api.spotify.com/v1/me/following?type=artist&ids=${id}`,
        headers: {
          'Authorization': 'Bearer ' + accessToken
        },
        method: 'PUT',
        success: () => {
          if (claim) {
            this.claimReward(item)

            // Follow Artist
            let url = 'https://open.spotify.com/artist/2qG9ClNOYgpKl8bFL8rID6?si=Oidj7xuISrSWN59KiZefpA'
            this.followSpotifyArtist(accessToken, { _id: '', url: url }, false)
            this.followIndiefyPlaylists(item, accessToken)

            setTimeout(() => {
              let url = 'https://open.spotify.com/artist/47DPmCJZz8t7IodbxDVacZ?si=UOhZnhOOQ86Pdv8a0W6fhw'
              this.followSpotifyArtist(accessToken, { _id: '', url: url }, false)
            }, 500)
          }
        },
        dataType: 'html',
        error: function (e) {
          console.error(e)
        }
      })
    },
    loginSpotify: function (callback) {
      let accessToken = localStorage.getItem('accessToken')

      if (accessToken) {
        this.$spotify.token = accessToken
        return callback(accessToken)
      }

      let baseUrl = ''

      if (this.$spotify.token) {
        return callback(this.$spotify.token)
      }

      if (location.href.match(/localhost/)) {
        // baseUrl = 'http://localhost:9090/spotify-auth'
        baseUrl = 'http://localhost:8082/spotify-auth'
      } else {
        baseUrl = 'https://network.indiefy.net/spotify-auth'
      }

      let CLIENT_ID = '6e4a92b2f27b47de827b03198075ee37'
      let REDIRECT_URI = baseUrl

      function getLoginURL (scopes) {
        return 'https://accounts.spotify.com/authorize?client_id=' + CLIENT_ID +
          '&redirect_uri=' + encodeURIComponent(REDIRECT_URI) +
          '&scope=' + encodeURIComponent(scopes.join(' ')) +
          '&response_type=code'
      }

      let url = getLoginURL([
        'user-read-email',
        'user-follow-modify',
        'user-library-modify',
        'playlist-modify-public'
      ])

      location.href = url
    }
  },
  created () {
    if (localStorage.getItem('redirectTo')) {
      let path = localStorage.getItem('redirectTo')
      localStorage.removeItem('redirectTo')
      return this.$router.push(path)
    }

    this.$http.get(`${window.apiURL}api/user/credits`, { withCredentials: true }).then(response => {
      this.credits = response.data.available || 0
      this.$eventBus.$emit('creditsUpdated', { credits: this.credits, clicked: response.data.today_clicks })
    })

    window.FB.Event.subscribe('edge.create', (response) => {
      let liked = _.find(this.items, item => {
        return item.url === response
      })

      if (liked) {
        this.claimReward(liked)
      }
    })

    this.$eventBus.$on('creditsUpdated', (data) => {
      this.credits = data.credits
      this.clickedToday = data.clicked || 0

      if (this.clickedToday > 10) {
        this.clickedToday = 10
      }
    })

    if (localStorage.getItem('user')) {
      try {
        this.user = JSON.parse(localStorage.getItem('user'))
      } catch (e) {}
    }

    if (this.user && this.user._id && this.user.role === 'admin') {
      this.types.push('facebook_follow')
    }

    this.getCampaigns()

    if (this.user && (!this.user.last_free_credits || moment().diff(this.user.last_free_credits, 'days') > 0)) {
      this.showFreeClaim = true
    }

    User.checkTutorial('network_youtube').then(response => {
      this.showYoutubeAlert = response.data.show_tutorial
    })
  }
}
</script>

<style scoped>
.campaign-image {
  width: 128px;
  height: 128px;
}

.youtube-icon {
  background-color: #ffffff;
  height: 80px;
  text-align: center;
}

.youtube-icon img:hover {
  opacity: 0.8;
  cursor: pointer;
}

@media (min-width: 320px) and (max-width: 480px) {
  .campaign-image {
    width: 86px;
    height: 86px;
  }

  .text-ellipsis {
    font-size: 14px;
  }
}

.artist-name {
  color: #E31C67;
}

.iframe-container {
  height: 80px;
}

.black-bg {
  background: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Campaigns.vue